import {
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from '@mui/icons-material/Close';
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import FlashLogo from "../../../../assests/svg/flash-coin.svg"

import { Link } from "react-router-dom";
import { scrollToSection } from "../../utils/scrollToSection";
import { getWhitepaperPdf } from "../../docs";
import Menubar from "../menu";
import { useSelector, useDispatch } from "react-redux";
import {
  Languagemodel,
  Translatechangemode,
  TranslateSetPack,
  loadLanguagePack,
} from "../../../../Slice/translateSlice";
import ReactFlagsSelect from "react-flags-select";
import '../header/style.css';

const FLAG_TO_LANG = {
  GB: "en",
  FR: "fr",
  DE: "de",
  ES: "es",
  SA: "ar",
  PT: "pt",
};

const FTheader = () => {
  const Navs = [
    {
      name: "Our Services",
      color: "#FBBF04",
      link: "services",
    },
    {
      name: "Roadmap",
      color: "#85898F",
      link: "roadmap",
    },
    {
      name: "App",
      color: "#85898F",
      link: "transfer",
    },
    {
      name: "Tokenomics",
      color: "#85898F",
      link: "tokenomics",
    },
    {
      name: "Whitepaper",
      color: "#85898F",
      link: "tokenomics",
    },
    {
      name: "Audit",
      color: "#85898F",
      link: "tokenomics",
    },
    {
      name: "NFT",
      color: "#85898F",
      link: "nft",
    },
    {
      name: "Partners",
      color: "#85898F",
      link: "partners",
    },
    {
      name: "Team",
      color: "#85898F",
      link: "team",
    },
    {
      name: "FAQ",
      color: "#85898F",
      link: "faq",
    },
    {
      name: "Contact",
      color: "#85898F",
      link: "Contact",
    },
  ];
  const languageState = useSelector((state) => state.translate.mode)
  const [menuStatus, SetmenuStatus] = useState(false);
  const dispatch = useDispatch()
  const Lang = useSelector(Languagemodel)
  const [selected, setSelected] = useState("GB");
  const handleSelected = async (code) => {
    const mode = FLAG_TO_LANG[code] || "en";
    setSelected(code);
    dispatch(Translatechangemode(mode));
    if (mode !== "en" && mode !== "fr") {
      const pack = await loadLanguagePack(mode);
      dispatch(TranslateSetPack({ mode, pack }));
    }
  };

  // If browser default is a lazy pack, hydrate it after first paint.
  useEffect(() => {
    if (languageState === "en" || languageState === "fr") return undefined;
    let cancelled = false;
    loadLanguagePack(languageState).then((pack) => {
      if (!cancelled) dispatch(TranslateSetPack({ mode: languageState, pack }));
    });
    return () => {
      cancelled = true;
    };
  }, [languageState, dispatch]);
  useEffect(() => {
    if (languageState === 'en') {
      setSelected("GB")
    }
    else if (languageState === 'fr') {
      setSelected("FR")
    }
    else if (languageState === 'es') {
      setSelected("ES")
    }
    else if (languageState === 'pt') {
      setSelected("PT")
    }
    else if (languageState === 'ar') {
      setSelected("SA")
    }
    else if (languageState === 'de') {
      setSelected("DE")
    }
  }, [languageState]);
  return (
    <>
      <Grid
        container
        sx={

          {
            mb: { lg: "0px", xs: "-10px" },
            // transform: 'scale(0.8)'
            position: 'fixed',
            zIndex: 99999999999,
            backgroundColor: 'black',
            top: 0,
            boxShadow: "0 4px 8px 0 rgb(108 98 98 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)"
          }
        }
      >
<Grid
          container
          sx={{
            backgroundColor: { lg: "none", xs: "black" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative"
          }}
        >
          <Menubar status={menuStatus} SetmenuStatus={SetmenuStatus} />
          <Grid
            item
            sm={12}
            md={12}
            sx={{
              padding: "10px 10px",
              display: { lg: "none", xs: "flex" },
              flexDirecion: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <IconButton
                aria-label={menuStatus ? "Close menu" : "Open menu"}
                onClick={() => { SetmenuStatus(!menuStatus) }}
              >
                {!menuStatus ? <MenuIcon fontSize="large" sx={{ color: "white" }} /> :
                  <CloseIcon fontSize="large" sx={{ color: "white" }} />
                }
              </IconButton>
            </Box>
            <Box
              component={Link}
              to="/"
              aria-label="Flash Technologies"
              sx={{
                marginRight: { lg: "0px", xs: "30px" },
                display: "flex",
                flexDirection: "row",

                alignItems: "center",
                gap: '10px',
                textDecoration: "none",
              }}
            >
              <img src={FlashLogo} height="40" width="40" alt="" />
              <span className="flash-wordmark" aria-hidden="true">
                {Lang["Flash Technologies"] || "Flash Technologies"}
              </span>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexdirection: "row",
                width: "103px",
                height: "40px"
              }}
            >
              <ReactFlagsSelect
                selected={selected}
                onSelect={(code) => handleSelected(code)}
                countries={["GB", "FR", "DE", "ES", "PT", "SA"]}
                customLabels={{ "GB": "EN", "SA": "AR", "FR": "FR", "DE": "DE", "PT": "PT", "ES": "ES" }}
              />
            </Box>
          </Grid>
        </Grid>
        
        <Grid
          className="container-box"
          item
          md={12}
          sx={{

            mt: { lg: "0px", xs: "0px" },
            padding: "0px 20px",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: "auto",
            marginRight: "auto",

          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              mb: { lg: "0px", xs: "10px" },
              display: { lg: "flex", xs: "none" },
              justifyContent: "space-between !important",
            }}
          >
            
            <Box sx={{ display: { lg: "none", xs: "none" } }}>
              <IconButton
              // aria-label="open drawer"
              // edge="end"
              // onClick={handleDrawerOpen}
              // sx={{ ...(open && { display: "none" }), color: "rgb(176, 41, 34)" }}
              >
                <MenuIcon fontSize="large" sx={{ color: "white" }} />
              </IconButton>
            </Box>
            <Box
              component={Link}
              to="/"
              aria-label="Flash Technologies"
              sx={{
                marginRight: { lg: "0px", xs: "50px" },
                display: "flex",
                gap: '10px',
                flexDirection: "row",
                alignItems: "center",
                justifyContent: 'center',
                paddingTop: { lg: "0px", xs: "-10px" },
                textDecoration: "none",
              }}
            >
              <img src={FlashLogo} width="40" height="40" alt="" />
              <span className="flash-wordmark" aria-hidden="true">
                {Lang["Flash Technologies"] || "Flash Technologies"}
              </span>
            </Box>
            
            <Grid>
              <Box
                sx={{
                  display: { lg: "flex", xs: "none" },
                  flexDirection: "row",
                  margin: "7px 10px",
                }}
              >
                {Navs.map((i) => {
                  return (
                    <Box
                      sx={{ margin: "10px 0px", textTransform: "capitalize" }}
                    >
                      <Typography
                        sx={{
                          color: `${i.color}`,
                          fontFamily: "Manrope !important",
                          fontSize: "12px !important",
                          fontWeight: "400 !important",
                          padding: "5px 10px",
                        }}
                      >
                        <div
                          className="menu-link"
                          sx={{
                            color: `${i.color}`,
                            fontFamily: "Manrope !important",
                            fontSize: "12px !important",
                            fontWeight: "400 !important",
                            lineHeight: "16.4px !important",
                            cursor: "pointer"
                          }}
                          href={i.link}
                          onClick={() => {
                            if (i.name === "Whitepaper") {
                              window.open(
                                getWhitepaperPdf(languageState),
                                "_blank",
                                "noopener,noreferrer"
                              );
                              return;
                            }
                            scrollToSection(i.link, i.name === "Medias" ? 100 : 55);
                          }}
                        >
                          {Lang[i.name]}
                        </div>
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
            <Grid
              sx={{
                paddingTop: { lg: "8px", xs: "6px" },
                width: "326px"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "0",
                  justifyContent: "end"
                }}
              >
                
                <div style={{ marginRight: "20px", marginTop: "3px" }}>
                  <ReactFlagsSelect
                    selected={selected}
                    onSelect={(code) => handleSelected(code)}
                    countries={["GB", "FR", "DE", "ES", "PT", "SA"]}
                    customLabels={{ "GB": "EN", "SA": "AR", "FR": "FR", "DE": "DE", "PT": "PT", "ES": "ES" }}
                  />
                </div>
                
                  
                  
                  
                
              </Box>
            </Grid>
          </Grid>{" "}
        </Grid>
      </Grid>
    </>
  );
};

export default FTheader;
